export enum InstitutionSort {
  InstitutionName = 1,
  InstitutionAddress = 2,
  ProgramTypes = 3
}